import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styles from '../style.module.less'
import mStore from '../../store'

@observer
export default class extends Component {
  render() {
    const {
      details: { expire_time, installment }
    } = mStore

    const orderWeight = {
      0: '首付款',
      1: '尾款1',
      2: '尾款2'
    }

    return (
      <div className={styles.header}>
        {installment && (
          <p>
            请于 {installment.expire_time} 前完成支付{
              orderWeight[installment.weight]
            }，若未及时付款，系统将自动终止订单。
          </p>
        )}
        {!installment && (
          <p>
            请于 {expire_time} 前完成支付，若未及时付款，系统将自动关闭订单。
          </p>
        )}
      </div>
    )
  }
}
